import axios from './productInstance'

const getShapeProfiles = async (page: number = 1, size: number = 100): Promise<any[] | null> => {
	try {
		const response = await axios.get(`/shapeprofiles/`, {
			params: { page, size },
		})
		return response.data.contents || response.data || []
	} catch (error) {
		console.error('Error fetching shape profile data:', error)
		return null
	}
}

export default getShapeProfiles
